import { ClientsTestimonials } from '../components/sections/ClientsTestimonials';
import { ClientsList } from '../components/sections/ClientsList';
import { ClientsCTA } from '../components/sections/ClientsCTA';

const Clients = () => (
  <div>
    <ClientsTestimonials />
    <ClientsList />
    <ClientsCTA />
  </div>
);

export default Clients;
